import { BoxAsset } from '@appTypes/BoxTypes'
import { MarketplaceItem } from '@appTypes/MarketplaceTypes'
import { chainConfig } from '@config'
import { getBoxMetadata } from '@services/BoxService'
import { oldMarketplaceService } from '@services/OldMarketplaceService'
import { useEffect, useState } from 'react'
import { useGlobalConfig } from './ConfigHook'

export function useMarketplaceListedItems(account: string, chainId: number) {
  const { paginationLimit } = useGlobalConfig()
  const [loading, setLoading] = useState(true)
  const [offset, setOffset] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [nfts, setNfts] = useState<MarketplaceItem[]>([])
  const config = chainConfig(chainId)
  const boxAddress = config?.box?.contract

  useEffect(() => {
    const getInitialNfts = async () => {
      setLoading(true)

      if (account) {
        const nftItems = await oldMarketplaceService(chainId).get721ItemsByLaunched(account)

        if (nftItems) {
          const nftItemsBox: BoxAsset[] = []

          await Promise.all(
            nftItems.map(async nft => {
              if (nft.id.toLowerCase() === boxAddress?.toLowerCase()) {
                const nftWithMetadata = await getBoxMetadata(nft.id, chainId)
                nftWithMetadata && nftItemsBox.push(nftWithMetadata)
              }
            })
          )

          const nftItemsWithBox: MarketplaceItem[] = []
          nftItems.forEach(nftItem => {
            const nftBoxItem = nftItemsBox.find(
              nftBox => nftItem.id.toLowerCase() === nftBox.boxAddress.toLowerCase() && nftItem.target.tokenId === nftBox.boxId.toString()
            )
            if (nftBoxItem) {
              const newNftItem = { ...nftItem, nftsCount: nftBoxItem.nftCount }
              nftItemsWithBox.push(newNftItem)
            } else {
              nftItemsWithBox.push(nftItem)
            }
          })
          if (chainId !== 1 || nftItemsWithBox.length < paginationLimit) {
            setHasMore(false)
          }
          setNfts(nftItemsWithBox)
          setOffset(nftItemsWithBox.length)
        }
      } else {
        setNfts([])
        setOffset(0)
      }
      setLoading(false)
    }

    getInitialNfts()
  }, [account, boxAddress, chainId, paginationLimit])

  const loadMore = async () => {
    if (account && chainId) {
      const nftItems = await oldMarketplaceService(chainId).get721ItemsByLaunched(account)

      if (nftItems) {
        const nftItemsBox: BoxAsset[] = []
        nftItems.map(async nft => {
          const nftWithMetadata = await getBoxMetadata(nft.id, chainId)
          if (nft.id.toLowerCase() === boxAddress?.toLowerCase()) {
            nftWithMetadata && nftItemsBox.push(nftWithMetadata)
          }
        })

        const boxesWithNftCount: MarketplaceItem[] = []
        nftItems.forEach(nftItem => {
          const nftBoxItem = nftItemsBox.find(
            nftBox => nftItem.id.toLowerCase() === nftBox.boxAddress.toLowerCase() && nftItem.target.tokenId === nftBox.boxId.toString()
          )
          if (nftBoxItem) {
            const newNftItem = { ...nftItem, nftsCount: nftBoxItem.nftCount }
            boxesWithNftCount.push(newNftItem)
          } else {
            boxesWithNftCount.push(nftItem)
          }
        })
        setNfts([...nfts, ...boxesWithNftCount])
        setOffset(offset + paginationLimit)
        if (nftItems.length < paginationLimit) {
          setHasMore(false)
        }
      }
    }
  }

  return { loading, hasMore, loadMore, nfts }
}
